module.exports = __webpack_public_path__ + "img/advice-placeholder.171e669a.svg";